import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-view-caso-uso',
  templateUrl: './dialog-view-caso-uso.component.html',
  styleUrls: ['./dialog-view-caso-uso.component.css']
})
export class DialogViewCasoUsoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
